<template>
  <section class="block-wrapper main-container search text-center pt-10 pb-20 px-5 md:px-10 mx-auto" :class="{'flex items-center justify-center':isLoadingInProgress}">
    <div
      class="mx-auto text-left overflow-hidden"
    >
      <BlockComponent :block-number="blockNumber" />
    </div>
  </section>
</template>

<script>
import BlockComponent from '../components/common/BlockComponent';
import { mapGetters } from 'vuex';

export default {
  name: 'BlockWrapper',
   components: {
    BlockComponent,
  },
  data: ()=> {
    return {
      blockNumber: null,
      isLoadingInProgress: false,
    }
  },
  watch: {
    '$route.params.blockNumber': {
      handler: function(search) {
        this.blockNumber = search
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.blockNumber = this.$route.params.blockNumber
  }
};
</script>

<style scoped>
.main-container {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>
